<!--billRecord 账单记录-->
<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :close-on-click-modal="false"
    title="账单记录"
    :visible="show"
    :before-close="beforeCloseDialog"
    @dialogclose="beforeCloseDialog"
    append-to-body
    ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <div slot="title" class="dialog-header-title">
      <span class="name">账单记录</span>
    </div>
    <div class="form_content" style="padding: 20px; height: 100%">
      <div ref="tablePanel" class="fullheight">
        <div class="top_search">
          <el-row style="height: 100%; width: 100%">
            <el-col :span="6" class="col_style">
              <el-date-picker
                v-model="code"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="6" class="col_style">
              <el-button type="primary" @click="loadData()">搜索</el-button>
            </el-col>
          </el-row>
          <el-button type="primary" plain @click="exportReport()">导出</el-button>
        </div>
        <div class="table_content">
          <el-table
            ref="ecoTable"
            :style="{
              height: `${tableMaxHeight}` + 'px'
            }"
            :max-height="tableMaxHeight"
            :data="templateData"
            tooltip-effect="dark"
            style="width: 100%"
            border
            :header-cell-style="headerCellStyle"
          >
            <el-table-column type="index" label="序号" width="55"> </el-table-column>
            <el-table-column prop="account_name" label="产品名称" show-overflow-tooltip> </el-table-column>
            <el-table-column prop="create_by_name_" label="使用人"> </el-table-column>
            <el-table-column prop="create_time_" label="消费时间"> </el-table-column>
            <el-table-column prop="id" label="业务ID"> </el-table-column>
            <el-table-column prop="consumer_name" label="消费名称"> </el-table-column>
            <el-table-column prop="billing_number" label="消费次数"> </el-table-column>
          </el-table>
          <div class="page_bean">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[10, 20, 40, 50, 100, 500]"
              :page-size.sync="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import form from '@/api/form'
export default {
  name: 'billRecordDialog',
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    tempValue: {
      type: Object,
      default: () => {}
    },
    tenantId: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      total: 0,
      drawerSize: '70%',
      pageSize: 20,
      currentPage: 1,
      templateData: [],
      boDefIdList: [],
      selectUploadId: null,
      selectModel: null,
      taVisible: false,
      tmVisible: false,
      tableMaxHeight: document.body.clientHeight - 220,
      activeName: 'first',
      code: ''
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.code = ''
          this.pageSize = 20
          this.currentPage = 1
          this.loadData()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    beforeCloseDialog() {
      this.$emit('closeBillingRecord')
    },
    submit() {},
    //表头样式
    headerCellStyle() {
      return {
        backgroundColor: '#F3F3F3',
        color: '#333333'
      }
    },
    //每页数量调整
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    //页数跳转
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadData()
    },
    // 动态计算表格的高度，自适应当前容器
    calcTableHeight(delay) {
      setTimeout(() => {
        if (!this.$refs.tablePanel) {
          return
        }
        const tablePanelHeight = this.$refs.tablePanel.$el.clientHeight
        this.tableMaxHeight = tablePanelHeight - 220
      }, delay || 0)
    },
    // 导出
    exportReport() {
      //8 ocr
      //3 企查查
      //10 e签宝
      const expField = 'account_name,create_by_name_,create_time_,id,consumer_name,billing_number'

      const param = {
        name: '账单记录',
        type: 'all',
        expField: Base64.encode(expField),
        displayField: [
          { name: 'account_name', desc: '产品名称' },
          { name: 'create_by_name_', desc: '使用人' },
          { name: 'create_time_', desc: '消费时间' },
          { name: 'id', desc: '业务ID' },
          { name: 'consumer_name', desc: '消费名称' },
          { name: 'billing_number', desc: '消费次数' }
        ],
        query: {
          querys: [
            {
              group: 'advance',
              value: this.tempValue.account_module,
              relation: 'AND',
              operation: 'IN',
              property: 'portal_sys_http_logs.dock_type'
            }
          ]
        },
        path: 'billing_records',
        params: {}
      }
      if (this.code) {
        param.query.querys.push({
          group: 'advance',
          value: this.code,
          relation: 'AND',
          operation: 'BETWEEN',
          property: 'portal_sys_http_logs.create_time_'
        })
      }
      this.$http.post('${data}/export/data/export', param).then((res) => {})
    },
    //初始化加载
    loadData(prop, sort) {
      let params = {
        pageBean: {
          page: this.currentPage,
          pageSize: this.pageSize,
          total: 0
        }
      }
      params.querys = [
        {
          group: 'advance',
          value: this.tempValue.account_module,
          relation: 'AND',
          operation: 'IN',
          property: 'portal_sys_http_logs.dock_type'
        }
      ]
      // 时间搜索
      if (this.code) {
        params.querys.push({
          group: 'advance',
          value: this.code,
          relation: 'AND',
          operation: 'BETWEEN',
          property: 'portal_sys_http_logs.create_time_'
        })
      }
      if (prop) {
        params.sorter = [{ property: prop, direction: sort }]
      }
      let subParams = {
        tenantId: this.tenantId
      }
      form.getbillRecordList(params, subParams).then((resp) => {
        this.templateData = resp.rows
        this.total = resp.total
      })
    }
  }
}
</script>

<style scoped>
.top_search {
  height: 45px;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.col_style {
  height: 100%;
  display: flex;
  align-items: center;
}
/deep/.el-input-group__append button.el-button {
  border-color: transparent;
  background-color: #377cff;
  color: white;
  border-top: 0;
  border-bottom: 0;
}
.button_group {
  height: 40px;
  display: flex;
  justify-content: right;
  align-items: center;
}
.page_bean {
  display: flex;
  justify-content: right;
  align-items: center;
}
</style>
